(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prod-d"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initTiltCards(root) {
    var cards = root.querySelectorAll('[data-tilt-card]');
    var maxTilt = 10; // degrees
    var isTouch = window.matchMedia('(hover: hover)').matches === false;

    if (isTouch) return; // skip tilt on touch devices

    cards.forEach(function (card) {
      var imageWrap = card.querySelector('.premium-fc-image-wrap');
      if (!imageWrap) return;

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;

        var centerX = rect.width / 2;
        var centerY = rect.height / 2;

        var rotateY = ((x - centerX) / centerX) * maxTilt;
        var rotateX = -((y - centerY) / centerY) * maxTilt;

        imageWrap.style.transform =
          'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) scale(1.06)';
      });

      card.addEventListener('mouseleave', function () {
        imageWrap.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.premium-fc-section').forEach(function (section) {
      initTiltCards(section);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.premium-fc-section');
    if (section) initTiltCards(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["round-c"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.sbc-list').forEach(function (list) {
    var section = list.closest('.sbc-section');
    if (!section) return;
    var dots = section.querySelectorAll('.sbc-dot');
    if (dots.length) {
      var cards = list.querySelectorAll('.sbc-card');

      var getCardWidth = function () {
        var gap = parseFloat(getComputedStyle(list).gap) || 0;
        return cards[0] ? cards[0].offsetWidth + gap : 0;
      };

      var updateActiveDot = function () {
        var cardWidth = getCardWidth();
        if (!cardWidth) return;
        var index = Math.round(list.scrollLeft / cardWidth);
        dots.forEach(function (dot, i) {
          var isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          dot.style.background = isActive ? dot.getAttribute('data-active-color') : dot.getAttribute('data-inactive-color');
        });
      };

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-index'), 10);
          list.scrollTo({ left: i * getCardWidth(), behavior: 'smooth' });
        });
      });

      list.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateActiveDot);
      });

      window.addEventListener('resize', updateActiveDot);
      updateActiveDot();
    }
  });

  if (window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('.sbc-card.sbc-tilt').forEach(function (card) {
      var maxTilt = 8;

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var rotateY = ((x - centerX) / centerX) * maxTilt;
        var rotateX = -((y - centerY) / centerY) * maxTilt;
        card.style.transform = 'perspective(600px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transform = 'perspective(600px) rotateX(0deg) rotateY(0deg) translateY(0)';
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
